import 'jquery'
import 'magnific-popup'
import Sticky from 'sticky-js'
import './contact-parallax'
import './newsletter'
import './popup-overlay'
import './scroll-reveal'

jQuery( document ).ready( function ( $ ) {

	if (window.innerWidth > 768) {
		var sticky = new Sticky('.intro__side', {
			bottomSpacing: 100
		} );
	}

	var $menuToggler = $( '.menu-toggler' )
	var $navPanel = $( '.header--inner__nav' )

	$menuToggler.on( 'click', function ( e ) {
		e.preventDefault()
		var isOpen = $( this ).hasClass( 'active' )
		$( this ).toggleClass( 'active' )
		$( this ).attr( 'aria-expanded', ! isOpen )
		$navPanel.slideToggle()
	} )

	// Close on Escape
	$( document ).on( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && $menuToggler.hasClass( 'active' ) ) {
			$menuToggler.removeClass( 'active' ).attr( 'aria-expanded', 'false' )
			$navPanel.slideUp()
			$menuToggler.trigger( 'focus' )
		}
	} )

	// Close on nav link click (mobile)
	$navPanel.on( 'click', 'a', function () {
		if ( window.innerWidth <= 991 ) {
			$menuToggler.removeClass( 'active' ).attr( 'aria-expanded', 'false' )
			$navPanel.slideUp()
		}
	} )
	if ( $( '.wp-block-gallery' ).length ) {
		$( '.wp-block-gallery' ).magnificPopup( {
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		} )
	}
	if ( $( '.popup-detail__gallery' ).length ) {
		$( '.popup-detail__gallery' ).magnificPopup( {
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		} )
	}
	if ( $( '.popup-overlay__gallery' ).length ) {
		$( '.popup-overlay__gallery' ).magnificPopup( {
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		} )
	}
	if ( $( '.lookbook-detail__gallery' ).length ) {
		$( '.lookbook-detail__gallery' ).magnificPopup( {
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		} )
	}

} )

// Throttled scroll handler for header class toggle
let scrollTicking = false
window.addEventListener( 'scroll', function () {
	if ( ! scrollTicking ) {
		window.requestAnimationFrame( function () {
			var scrolled = window.pageYOffset > 100
			document.querySelector( '.header' ).classList.toggle( 'scrolled', scrolled )
			scrollTicking = false
		} )
		scrollTicking = true
	}
}, { passive: true } )